import { ShoppingCart, Stethoscope, Car, Users, Home, HeartHandshake } from "lucide-react";

export const SERVICE_TYPES = [
  { value: "errands", label: "Errands & Groceries", icon: ShoppingCart },
  { value: "doctor_visit", label: "Doctor Visit", icon: Stethoscope },
  { value: "surgery_transport", label: "Surgery Transport", icon: Car },
  { value: "companion", label: "Companionship & Walks", icon: Users },
  { value: "household", label: "Household Help", icon: Home },
  { value: "other", label: "Other Support", icon: HeartHandshake },
];

export const serviceMeta = (value) =>
  SERVICE_TYPES.find((s) => s.value === value) || SERVICE_TYPES[SERVICE_TYPES.length - 1];

export function Stars({ rating = 0, size = "text-base" }) {
  const full = Math.round(rating);
  return (
    <span className={`${size} text-[#D99B26] tracking-tight`}>
      {"★".repeat(full)}
      <span className="text-slate-300">{"★".repeat(5 - full)}</span>
    </span>
  );
}

export function Badge({ children, color = "teal", testid }) {
  const map = {
    teal: "bg-[#E8F4F1] text-[#2E7D6B]",
    orange: "bg-[#FBEBE4] text-[#C25832]",
    gold: "bg-[#FFF7E6] text-[#A9741A]",
    red: "bg-red-50 text-red-600",
    slate: "bg-slate-100 text-slate-600",
    green: "bg-green-50 text-green-700",
  };
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-sm font-semibold ${map[color]}`}>
      {children}
    </span>
  );
}
